import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('LIQUID_SPLASH', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  const gravity = config.collisionEffectGravity || 0.5;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = -Math.PI / 2 + (rnd - 0.5) * Math.PI;
    const speed = 5 + rnd * 10;
    const t = elapsed / 16.6;
    const x = e.pos.x + Math.cos(angle) * speed * t;
    const y = e.pos.y + Math.sin(angle) * speed * t + 0.5 * gravity * t * t;

    const stretch = Math.atan2(Math.sin(angle) * speed + gravity * t, Math.cos(angle) * speed);
    ctx.fillStyle = determineColor(i, particles);
    ctx.globalAlpha = (1 - progress);
    ctx.save(); ctx.translate(x, y); ctx.rotate(stretch);
    ctx.beginPath(); ctx.ellipse(0, 0, 6 * (1 - progress), 2 * (1 - progress), 0, 0, Math.PI * 2);
    ctx.fill(); ctx.restore();
  }
});
